import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div data-testid="datenschutz-page" className="min-h-screen bg-paper font-jakarta text-[#0A272C]">
      <header className="border-b border-[#0A272C]/10 bg-surface/80 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
          <a href="/" data-testid="datenschutz-logo" className="flex items-center hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="BUNDLER FM" className="h-7 w-auto" />
          </a>
          <a
            href="/"
            data-testid="datenschutz-back-link"
            className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#003940] transition-colors"
          >
            <ArrowLeft size={15} />
            Zurück zur Startseite
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-16 space-y-10">
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#003940]">Rechtliches</p>
          <h1 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">Datenschutzerklärung</h1>
        </div>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">1. Verantwortlicher</h2>
          <p className="text-slate-700 leading-relaxed">
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            <br />
            BUNDLER FM — UG in Gründung, Zum Isetal 1, 38518 Gifhorn, Telefon: +49 5371 9394742 (Festnetz), Mobil (DE): +49 177 2185585, Mobil (SRB): +381 60 561 6892, E-Mail: info@bundler-fm.de
            <br />
            Vertreten durch: Aleksandar Veljkovic (Geschäftsführung)
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">2. Zugriffsdaten und Hosting</h2>
          <p className="text-slate-700 leading-relaxed">
            Beim Aufruf dieser Website verarbeitet der Hosting-Dienstleister automatisch technische Zugriffsdaten
            (z.&nbsp;B. IP-Adresse, Datum und Uhrzeit des Aufrufs, Browsertyp), die für den sicheren Betrieb der Website
            erforderlich sind. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren
            Betrieb der Website).
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">3. Kontaktformular</h2>
          <p className="text-slate-700 leading-relaxed">
            Bei Nutzung des Kontaktformulars verarbeiten wir Ihren Namen, Ihre E-Mail-Adresse und Ihre Nachricht, um
            Ihre Anfrage zu bearbeiten. Ihre Nachricht wird mithilfe eines KI-Dienstes automatisch kategorisiert und an
            den zuständigen Ansprechpartner in unserem Unternehmen weitergeleitet. Rechtsgrundlage ist Art. 6 Abs. 1
            lit. b DSGVO (vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
            effizienten Bearbeitung von Anfragen). Die Daten werden nur so lange gespeichert, wie es für die
            Bearbeitung Ihrer Anfrage erforderlich ist.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">4. Admin-Bereich</h2>
          <p className="text-slate-700 leading-relaxed">
            Der geschützte Admin-Bereich ist ausschließlich für autorisierte Mitarbeitende bestimmt. Anmeldeversuche
            werden zum Schutz vor Missbrauch protokolliert (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">5. Externe Inhalte und Dienste</h2>
          <p className="text-slate-700 leading-relaxed">
            Diese Website lädt Schriftarten über Google Fonts sowie einzelne Bild- und Videoinhalte über die Dienste
            Pexels und Unsplash. Dabei wird Ihre IP-Adresse an die jeweiligen Anbieter übertragen. Rechtsgrundlage ist
            Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer ansprechenden Darstellung). Marketing-Cookies
            oder Tracking-Werkzeuge setzen wir nicht ein.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">6. Ihre Rechte</h2>
          <p className="text-slate-700 leading-relaxed">
            Sie haben das Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten, auf Berichtigung, Löschung,
            Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung. Wenden Sie
            sich hierzu an info@bundler-fm.de.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">7. Beschwerderecht</h2>
          <p className="text-slate-700 leading-relaxed">
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
            personenbezogenen Daten durch uns zu beschweren.
          </p>
        </section>

        <p className="text-xs text-slate-500 font-mono border-t border-slate-200 pt-6">
          Stand: September 2026
        </p>
      </main>
    </div>
  );
}
